import { render, staticRenderFns } from "./CompetitionFilterArtLayout.vue?vue&type=template&id=24f7f0c6&scoped=true"
import script from "./CompetitionFilterArtLayout.vue?vue&type=script&lang=js"
export * from "./CompetitionFilterArtLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f7f0c6",
  null
  
)

export default component.exports